import axios from "axios";

const httpClient = axios.create({
    baseURL: "",
    headers: {
        "Content-type": "application/json",
    },
});

// Add response interceptor to handle 401 errors
httpClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            try {
                const session = JSON.parse(localStorage.getItem("esignature") || "{}");
                // Magic-link users authenticate via token in URL; avoid redirect loop to login on transient 401s
                if (session.isMagicLink) {
                    return Promise.reject(error);
                }
            } catch (_e) {
                /* ignore */
            }
            localStorage.removeItem('esignature');
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default httpClient;
